import { useState, useEffect } from 'react';
import firebase from 'firebase/app';

export function useFormerTeamsList(clientId) {
    const [formerTeams, setFormerTeams] = useState(null);

    useEffect(() => {
        if (!clientId) {
            setFormerTeams([]);
            return;
        }

        const db = firebase.firestore();
        const query = db
            .collectionGroup('members')
            .where('clientId', '==', clientId)
            .where('isDeleted', '==', true)
            .orderBy('updatedAt', 'desc');

        const unsubscribe = query.onSnapshot(
            async (snapshot) => {
                const list = snapshot.docs.map((doc) => {
                    const data = doc.data();
                    const pathParts = doc.ref.path.split('/');
                    const teamId = pathParts.length >= 2 ? pathParts[1] : (data.teamId || null);
                    return {
                        id: doc.id,
                        teamId,
                        teamName: data.teamName,
                        updatedAt: data.updatedAt,
                        ...data,
                    };
                });

                if (list.length > 0) {
                    const teamIds = [...new Set(list.map((i) => i.teamId).filter(Boolean))];
                    const teamSnaps = await Promise.all(
                        teamIds.map((tid) => db.collection('teams').doc(tid).get())
                    );
                    const ownerByTeam = {};
                    teamSnaps.forEach((snap, idx) => {
                        if (snap.exists) {
                            ownerByTeam[teamIds[idx]] = snap.data().teamOwnerClientId;
                        }
                    });
                    list.forEach((item) => {
                        item.teamOwnerClientId = ownerByTeam[item.teamId];
                    });
                }

                setFormerTeams(list);
            },
            (err) => {
                console.error('useFormerTeamsList error:', err);
                setFormerTeams([]);
            }
        );

        return () => unsubscribe();
    }, [clientId]);

    return formerTeams;
}
